import { queries } from "../../../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";
import { networkRoleDefaultsForSpace } from "../../../lib/networkGrantsForSpace";
import { SupplierAccessTab } from "../../SupplierAccessTab";

export function NetworkAccessTab({
  networkId,
  canManage,
}: {
  networkId: string;
  canManage: boolean;
}) {
  const [network] = useQuery(queries.loadNetwork({ networkId }));
  const [groupAccess] = useQuery(queries.networkGroupAccess({ networkId }));
  if (!network) return null;
  return (
    <SupplierAccessTab
      scopeId={networkId}
      scopeKind="network"
      scopeGrants={network.roleGrantsAsScope}
      supplierRelation="space_uses_networks"
      roleDefaultsForSpace={networkRoleDefaultsForSpace}
      resourceLabel="network"
      accessDescription="Add members, groups, or a whole space, and choose their role."
      groupAccess={groupAccess}
      canManage={canManage}
    />
  );
}
